/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Fmt_SaveInputs */

const en_vc_fmt_save = /** @type {(inputs: Vc_Fmt_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves and exports`)
};

const zh_vc_fmt_save = /** @type {(inputs: Vc_Fmt_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以保存和导出`)
};

/**
* | output |
* | --- |
* | "Saves and exports" |
*
* @param {Vc_Fmt_SaveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_fmt_save = /** @type {((inputs?: Vc_Fmt_SaveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Fmt_SaveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_fmt_save(inputs)
	return zh_vc_fmt_save(inputs)
});
export { vc_fmt_save as "vc.fmt.save" }